<!--tab-->
<template>
  <van-swipe :style="{height: heightPx + 'px'}" vertical :autoplay="3000" :show-indicators="false" class="travelanno">
    <van-swipe-item v-for="(items,index) in dataList" :key="index" @click="turnTo(items)">
      <div class="anno-swiper-tab-box">
        <smllabel v-if="isBorderStyle" :txtColor="items.colorStr" :borderColor="items.colorStr" :domHieght="17" >{{items.tags}}</smllabel>
        <smllabel v-else :txtColor="'#fff'" :bgColor="items.colorStr" :domHieght="17" >{{items.tags}}</smllabel>
      </div>
      <div class="swiper-content-text">{{items.content}}</div>
    </van-swipe-item>
  </van-swipe>
</template>

<script>
    import smllabel from './small-label'
    export default {
        components: {
            // eslint-disable-next-line vue/no-unused-components
            smllabel
        },
        props: {
            // 数据
            dataList: {
                type: Array,
                default: () => {
                    return [];
                }
            },
            heightPx: {
                type: String,
                default: ''
            },
            isBorderStyle: {
                type: Boolean,
                default: false
            }
        },
        data () {
            return {};
        },
        computed: {},
        methods: {
            turnTo (items) {
                if (items.url) {
                    window.yyn.invokeJSB(
                        'openWindow', {
                            openUrl: `${this.globalApp.getSystemInfo().host}${items.url}`,
                            isFullScreen: 0,
                            setTitle: '',
                            needLoading: 1
                        },
                        cb => {
                            console.log(cb, 'callback');
                        }
                    );
                    console.log('跳转:', `${this.globalApp.getSystemInfo().host}${items.url}`)
                } else {
                    console.log('没取到url')
                }
            }
        },
        mounted () {}
    };
</script>

<style scoped lang="less">
.travelanno{
      &::v-deep .van-swipe-item {
        height: 100%;
        display: flex;
        align-items: center;

          .anno-swiper-tab-box{
            position: relative;
            margin-right: 8px;

          }

          .swiper-content-text {
            flex: 1;
            font-size: 12px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(102, 102, 102, 1);
            line-height: 17px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            margin-right: 10px;
          }
      }

}

</style>
